import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("head", null, [
  /*#__PURE__*/_createElementVNode("link", {
    rel: "stylesheet",
    href: "https://use.fontawesome.com/releases/v5.3.1/css/all.css",
    integrity: "sha384-mzrmE5qonljUremFsqc01SB46JvROS7bZs3IO2EmfFsd15uHvIt+Y8vEf7N7fWAU",
    crossorigin: "anonymous"
  })
], -1)
const _hoisted_2 = { class: "home" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, " Join ", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roomName) = $event)),
          placeholder: "Room Name",
          name: "search",
          class: "searchbar"
        }, null, 512), [
          [_vModelText, _ctx.roomName]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.joinRoom && _ctx.joinRoom(...args))),
          class: "search_button"
        }, _hoisted_5)
      ])
    ])
  ], 64))
}